import React, { useState } from 'react';
import { SignaturePad } from '../../common/SignaturePad';
import { UNTERSCHRIFT_MAX_BREITE } from '../../sifa/public/teilnahmeSeiteLogic';
import { FEHLERKASTEN, HINWEISKASTEN, KNOPF_PRIMAER, KNOPF_SEKUNDAER } from '../../sifa/public/teilnahmeSeiteStil';
import { UNTERSCHRIFT_TITEL } from './einweisungTeilnahmeLogic';

/**
 * Unterschrift am PC: das SignaturePad liegt als Overlay ueber der Seite und
 * wird mit der Maus bedient. Keine QR-Bruecke aufs Handy (Plan §1.3) — auf
 * der Baustelle scannt man ohnehin mit dem Handy, und dort rendert die Seite
 * das SignaturePad direkt im Vollbild (EinweisungTeilnahmePage).
 *
 * Das Overlay ist beim Betreten des Schritts sofort offen; „Abbrechen" laesst
 * die Karte mit Hinweis und Zurueck-Knopf stehen, von der aus es wieder
 * aufgeht.
 */
export const EinweisungUnterschrift: React.FC<{
  busy: boolean;
  fehler: string | null;
  onUnterschrift: (dataUrl: string) => void;
  onZurueck: () => void;
}> = ({ busy, fehler, onUnterschrift, onZurueck }) => {
  const [offen, setOffen] = useState(true);

  return (
    <div className="space-y-5">
      <div className="space-y-1">
        <h2 className="text-xl font-bold text-slate-900">Unterschrift</h2>
        <p className="text-slate-600">
          Mit deiner Unterschrift bestätigst du, dass du die Einweisung in den SiGe-Plan erhalten und verstanden hast.
        </p>
      </div>

      {fehler && !offen && (
        <div className={FEHLERKASTEN} role="alert">
          {fehler}
        </div>
      )}

      <div className={HINWEISKASTEN}>Am PC unterschreibst du mit der Maus im Unterschriftenfeld.</div>

      <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-between">
        <button type="button" onClick={onZurueck} disabled={busy} className={KNOPF_SEKUNDAER}>
          Zurück
        </button>
        <button type="button" onClick={() => setOffen(true)} disabled={busy} className={KNOPF_PRIMAER}>
          Mit der Maus unterschreiben
        </button>
      </div>

      {offen && (
        <SignaturePad
          alsOverlay
          titel={UNTERSCHRIFT_TITEL}
          hinweis="Bitte mit der Maus im Feld unterschreiben und übernehmen."
          maxBreite={UNTERSCHRIFT_MAX_BREITE}
          uebernehmenLabel="Unterschrift übernehmen"
          busy={busy}
          fehler={fehler}
          onUebernehmen={onUnterschrift}
          onAbbrechen={() => setOffen(false)}
        />
      )}
    </div>
  );
};
